export const SET_NAVBAR_NOTIFICATIONS = 'SET_NAVBAR_NOTIFICATIONS'
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const TOGGLE_UNREAD_FILTER = 'TOGGLE_UNREAD_FILTER'
export const TOGGLE_READ_FILTER = 'TOGGLE_READ_FILTER'
export const SET_FILTERED_TYPES = 'SET_FILTERED_TYPES'
export const INCREASE_LIMIT = 'INCREASE_LIMIT'
export const SET_TOTAL_NOTIFICATIONS = 'SET_TOTAL_NOTIFICATIONS'
export const REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS = "REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS"